"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Core = void 0;
var _redux = require("redux");
var _reduxObservable = require("redux-observable");
var _middleware = require("./com/middleware");
var _KeySubscribe = require("./KeySubscribe");
var _Channel = require("../common/enums/Channel");
var _keyboardHandler = require("../../utils/keyboardHandler");
var _languageService = require("../../utils/languageService");
var _platformService = _interopRequireDefault(require("../../utils/platformService"));
var _noSleep = require("../../utils/noSleep");
var _logger = _interopRequireDefault(require("../../utils/logger"));
var _version = require("../../version");
var _createReducerManager = require("./createReducerManager");
var _root = require("./root");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Core = exports.Core = /*#__PURE__*/function () {
  function Core() {
    _classCallCheck(this, Core);
    /**
     * If the game can handle blitz or not.
     */
    _defineProperty(this, "blitzSupport", void 0);
    _defineProperty(this, "_store", void 0);
    /**
     * Subscribe to a key in the store.
     * By default it will cal the callback with the current state.
     */
    _defineProperty(this, "subscribe", void 0);
    _defineProperty(this, "dispatch", void 0);
    /**
     * Get the current state of the store.
     */
    _defineProperty(this, "getState", void 0);
    /**
     * Translate a key to a string. This is a global translation service.
     */
    _defineProperty(this, "translate", void 0);
    /**
     * Register a translation for a language, can be used to add translations to the global translation service.
     * Latest registration will overwrite the previous one in case same key is present.
     * @param lang the language to register the translations for.
     * @param translations the translations to register for the language. {key: string, value: string}
     */
    _defineProperty(this, "registerTranslation", void 0);
    _defineProperty(this, "loaderService", void 0);
    _defineProperty(this, "paytable", void 0);
    _defineProperty(this, "gameController", void 0);
    _defineProperty(this, "loader", void 0);
    _defineProperty(this, "_reducerManager", void 0);
    /**
     * Manual access to the window listener retrigger.
     */
    _defineProperty(this, "resize", void 0);
    _defineProperty(this, "_epicMiddleware", void 0);
    _logger["default"].debug("Core Instance created.");

    // check if the state is already created by setting/getting a global flag. Failsafe to prevent multiple state instances.
    if (window["__DRAGON_STATE_CREATED__"]) {
      throw new Error("DRAGON State already created");
    }
    window["__DRAGON_STATE_CREATED__"] = true;

    // say pixi hello when running in dev. to get versions etc.
    if (_platformService["default"].isDev()) {
      console.log(_version.LIB_VERSION);
    }
    this._epicMiddleware = (0, _reduxObservable.createEpicMiddleware)();
    var cmw = new _middleware.ComMiddleWare();
    this._reducerManager = (0, _createReducerManager.createReducerManager)(_root.rootReducer);

    // needed for redux devtools (chrome extension)
    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    if (composeEnhancers) {
      // This is only if redux dev tools are available.
      this._store = (0, _redux.legacy_createStore)(this._reducerManager.reduce, composeEnhancers((0, _redux.applyMiddleware)(this._epicMiddleware, cmw.middleware)));
    } else {
      //@ts-ignore
      this._store = (0, _redux.legacy_createStore)(this._reducerManager.reduce, (0, _redux.applyMiddleware)(this._epicMiddleware, cmw.middleware));
    }
    this._epicMiddleware.run(_root.rootEpic);
    this.dispatch = this._store.dispatch;
    this.getState = this._store.getState;
    var keySubscribe = new _KeySubscribe.KeySubscribe(this._store);
    this.subscribe = keySubscribe.subscribe;
    var fullscreenSupport = _platformService["default"].checkFullScreenSupport();

    // if mobile, and fullscreen support
    if (fullscreenSupport && this.getState().config.channel == _Channel.Channel.Mobile) _platformService["default"].createFullScreenTrap();
    new _keyboardHandler.KeyboardHandler();

    /** No Sleep, prevent dimming etc on mobile. */
    var noSleep = new _noSleep.NoSleep();
    document.addEventListener('click', function enableNoSleep() {
      document.removeEventListener('click', enableNoSleep, false);
      noSleep.enable();
    }, false);
    var t = new _languageService.LanguageService();
    this.translate = t.translate;
    this.registerTranslation = t.registerTranslations;
  }

  /**
   *  add an epic and ar reducer to the state.
   *
   * @param key
   * @param reducer
   * @param epic
   */
  return _createClass(Core, [{
    key: "AddModule",
    value: function AddModule(key, reducer, epic) {
      this._reducerManager.add(key, reducer);
      this._epicMiddleware.run(epic);
    }

    /**
     *  Register a custom middleware for your game. This gets hooked into the pipe of actions and can emit new actions based on that.
     *
     * 
     * @param epic an epic that listens to actions to dispatch new actions.
     */
  }, {
    key: "RegisterGameMiddleware",
    value: function RegisterGameMiddleware(epic) {
      this._epicMiddleware.run(epic);
    }

    /**
     * Special version of RegisterGameMiddleware that flags that the game can handle Blitz Features.
     *
     * @param epic
     */
  }, {
    key: "RegisterBlitzFeatureHandler",
    value: function RegisterBlitzFeatureHandler(epic) {
      this.blitzSupport = true;
      this._epicMiddleware.run(epic);
    }

    /**
     * Register the game loader into the state.
     * @param loader 
     */
  }, {
    key: "RegisterLoader",
    value: function RegisterLoader(loader) {
      this.loader = loader;
      //for bw comp
      this.loaderService = loader;
    }
  }]);
}();
var CORE = new Core();
var _default = exports["default"] = CORE;
//# sourceMappingURL=Core.js.map